import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Legacy from "@/components/site/Legacy";
import Manifesto from "@/components/site/Manifesto";
import Studio from "@/components/site/Studio";
import Catalog from "@/components/site/Catalog";
import SelectedWork from "@/components/site/SelectedWork";
import ReelsShowcase from "@/components/site/ReelsShowcase";
import Infrastructure from "@/components/site/Infrastructure";
import ClientsMarquee from "@/components/site/ClientsMarquee";
import Footer from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppButton";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import AdminLogin from "@/pages/AdminLogin";
import AdminQuotes from "@/pages/AdminQuotes";
import AdminPortfolio from "@/pages/AdminPortfolio";
import AdminReels from "@/pages/AdminReels";
import ProtectedRoute from "@/components/ProtectedRoute";

function Home() {
  return (
    <SmoothScroll>
      <div className="App paper-grain bg-[#F4F4F0] text-black">
        <Nav />
        <main>
          <Hero />
          <Legacy />
          <Manifesto />
          <Studio />
          <Catalog />
          <SelectedWork />
          <ReelsShowcase />
          <Infrastructure />
          <ClientsMarquee />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </SmoothScroll>
  );
}

function AdminRoute({ children }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

export default function App() {
  return (
    <AuthProvider>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/quotes" element={<AdminRoute><AdminQuotes /></AdminRoute>} />
            <Route path="/admin/portfolio" element={<AdminRoute><AdminPortfolio /></AdminRoute>} />
            <Route path="/admin/reels" element={<AdminRoute><AdminReels /></AdminRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              color: "#F4F4F0",
              border: "1px solid #F4F4F0",
              borderRadius: 0,
              fontFamily: "JetBrains Mono, monospace",
              fontSize: 12,
              letterSpacing: "0.05em",
            },
          }}
        />
      </LangProvider>
    </AuthProvider>
  );
}
